import { formatGhostElapsed } from "pages/PlatformAdmin/Ghost/ghostSession.utils";

export const formatGhostSessionElapsed = (elapsedSeconds, startedAt = null) => {
  if (Number.isFinite(elapsedSeconds)) {
    const totalSeconds = Math.max(0, Math.floor(elapsedSeconds));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [hours, minutes, seconds]
      .map((value) => String(value).padStart(2, "0"))
      .join(":");
  }

  if (startedAt) {
    return formatGhostElapsed(startedAt);
  }

  return "—";
};

export const formatGhostParticipant = (participant) => {
  if (!participant) {
    return "—";
  }

  if (participant.name && participant.email) {
    return `${participant.name} (${participant.email})`;
  }

  return participant.name || participant.email || "—";
};

export const formatGhostTenantLabel = (tenant) => {
  if (!tenant?.sp_name) {
    return "—";
  }

  return tenant.sp_name;
};

export const DEFAULT_GHOST_SESSION_FILTERS = {
  search: "",
  page: 1,
  perPage: 25,
};

export const buildGhostSessionsQuery = (
  filters,
  basePath = "super-admin/ghost/sessions"
) => {
  const params = new URLSearchParams();

  if (filters.search) {
    params.append("search", filters.search);
  }

  params.append("page", String(filters.page || 1));
  params.append("per_page", String(filters.perPage || 25));

  const query = params.toString();
  return query ? `${basePath}?${query}` : basePath;
};

